import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePopUp from "./date_popup.js";
import TaskPopUp from "./task_popup.js";
import "../styles/search_popup.css";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const SearchPopUp = (props) => {
  const [hearings, setHearings] = useState([]);
  const [hearingsData, setHearingsData] = useState([]);
  const [tasksData, setTasksData] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [dateId, setDateId] = useState("");
  const [showTask, setShowTask] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [works, setWorks] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [timer, setTimer] = useState(null);
  const [clientsSygns, setClientsSygns] = useState([]);

  const fetchHearings = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearingsData(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchHearingsAll = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearingsData(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchClientsSygns = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygns(data);
      })
      .catch((error) => {});
  };

  const fetchTasks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasksData(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchTasksAll = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasksData(
          data.filter((el) =>
            props.user.archSpraw === "1" ? el.arch === "0" : el.arch === "0"
          )
        );
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    if (props.team === 0) {
      fetchHearingsAll();
      fetchClientsSygns();
      fetchTasksAll();
    } else {
      fetchHearings();
      fetchClientsSygns();
      fetchTasks();
    }
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const closeDatePopUp = (e) => {
    setShowDate(!showDate);
    setDateId("");
    getData();
  };

  const showDatePopUp = (e) => {
    setDateId(e.target.value);
    setShowDate(true);
    setShowTask(false);
  };

  const closeTaskPopUp = (e) => {
    setShowTask(!showTask);
    getData();
  };

  const showTaskPopUp = (e) => {
    setTaskId(e.target.value);
    setShowTask(true);
    setShowDate(false);
  };

  const inputChanged = (e) => {
    setSearch(e.target.value);

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      searchData(e.target.value);
    }, 500);

    setTimer(newTimer);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    searchData(e.target.value);
  };

  const searchData = (filter) => {
    var clientId = 0;

    if (filter.length === 0) {
      setHearings([]);
      setWorks([]);
    } else {
      var cs = clientsSygns.filter((el) =>
        el.sygn
          .toString()
          .toLowerCase()
          .replaceAll(" ", "")
          .includes(filter.toString().toLowerCase().replaceAll(" ", ""))
      );
      if (cs.length > 0) {
        clientId = cs[0].clientId;
      }

      var newHearingsArray = hearingsData.filter(
        (el) =>
          (el.name
            ? el.name
                .toString()
                .toLowerCase()
                .includes(filter.toString().toLowerCase())
            : false) ||
          (el.sygn
            ? el.sygn
                .toString()
                .toLowerCase()
                .replaceAll(" ", "")
                .includes(filter.toString().toLowerCase().replaceAll(" ", ""))
            : false) ||
          (+clientId > 0 ? +el.clientId === +clientId : false)
      );
      newHearingsArray = newHearingsArray.sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
      });
      setHearings(newHearingsArray);
      var newTasksArray = tasksData.filter(
        (el) =>
          (el.client_name
            ? el.client_name
                .toString()
                .toLowerCase()
                .includes(filter.toString().toLowerCase())
            : false) ||
          (el.syng
            ? el.sygn
                .toString()
                .toLowerCase()
                .replaceAll(" ", "")
                .includes(filter.toString().toLowerCase().replaceAll(" ", ""))
            : false) ||
          (+clientId > 0 ? +el.clientId === +clientId : false)
      );
      newTasksArray = newTasksArray.sort(function (a, b) {
        return new Date(b.final_date) - new Date(a.final_date);
      });
      setWorks(newTasksArray);
    }
  };

  return (
    <>
      {showDate ? (
        <>
          <DatePopUp
            dateID={dateId}
            hearingsData={props.hearingsData}
            hearingsSheetData={props.hearingsSheetData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            close={closeDatePopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={props.history}
            checkPermissions={props.checkPermissions}
            substitutesData={props.substitutesData}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archDateTeam2={props.archDateTeam2}
            archDate={props.archDate}
            filesData={props.filesData}
            clientsData={props.clientsData}
            user={props.user}
            logClientAction={props.logClientAction}
          />
        </>
      ) : (
        ""
      )}
      {showTask ? (
        <>
          <TaskPopUp
            taskID={taskId}
            hearingsData={props.hearingsData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            closeTaskPopUp={closeTaskPopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={props.history}
            checkPermissions={props.checkPermissions}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archTasksTeam2={props.archTasksTeam2}
            archTasks={props.archTasks}
            filesData={props.filesData}
            clientsData={props.clientsData}
            user={props.user}
            logClientAction={props.logClientAction}
          />
        </>
      ) : (
        ""
      )}

      {showDate || showTask ? (
        ""
      ) : (
        <>
          <div className="mainContainerDatePopUp">
            {loading ? (
              <Loading id="popUpLoading" />
            ) : (
              <>
                <div className="mainContainerSearchPopUp">
                  <div style={{ width: "100%" }} className="closeBox">
                    <button className="closeClientButton" onClick={props.close}>
                      X
                    </button>
                  </div>
                  <div className="inputBox_search">
                    <div className="inputCol_flex">
                      <label id="search_label">
                        imię | nazwisko | sygnatura
                      </label>
                      <input
                        type="text"
                        id="search"
                        name="signature"
                        value={search}
                        onChange={inputChanged}
                      />
                    </div>
                  </div>
                </div>
                {works.length === 0 && hearings.length === 0 ? (
                  <div className="hearingTitle">Nie znaleziono wyników!</div>
                ) : (
                  <>
                    <div className="hearingTitle">
                      Wyniki wyszukiwania dla:{" "}
                      <span className="highlight">{search}</span>
                    </div>
                    <div className="hearingTitleSub">
                      Ilość rozpraw: {hearings.length} | Ilość zadań:{" "}
                      {works.length}
                    </div>
                    <div className="hearings_history_box">
                      <div className="hearings_history_title">ROZPRAWY</div>
                      <div className="hearings_data_box">
                        <div
                          id="hearings_data_header"
                          className="hearings_data_box_row"
                        >
                          <div className="hearings_data_box_col">
                            Data rozprawy
                          </div>
                          <div className="hearings_data_box_col">Klient</div>
                          <div className="hearings_data_box_col">Sygnatura</div>
                          <div className="hearings_data_box_col">Temat</div>
                          <div className="hearings_data_box_col"></div>
                        </div>
                        {hearings.map((el) => (
                          <>
                            <div className="hearings_data_box_row">
                              <div className="hearings_data_box_col">
                                {el.date}
                              </div>
                              <div className="hearings_data_box_col">
                                {el.name}
                              </div>
                              <div className="hearings_data_box_col">
                                {el.sygn}
                              </div>
                              <div className="hearings_data_box_col">
                                {el.subject}
                              </div>
                              <div className="hearings_data_box_col">
                                <button
                                  className="viewButton"
                                  value={el.id}
                                  onClick={showDatePopUp}
                                >
                                  PRZEJDŹ
                                </button>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                    <div className="hearings_history_box">
                      <div className="hearings_history_title">ZADANIA</div>
                      <div className="hearings_data_box">
                        <div
                          id="hearings_data_header"
                          className="hearings_data_box_row"
                        >
                          <div className="hearings_data_box_col">
                            Termin wykonania
                          </div>
                          <div className="hearings_data_box_col">Klient</div>
                          <div className="hearings_data_box_col">Zadanie</div>
                          <div className="hearings_data_box_col">
                            Osoba odpowiedzialna
                          </div>
                          <div className="hearings_data_box_col"></div>
                        </div>
                        {works.map((el) => (
                          <>
                            <div className="hearings_data_box_row">
                              <div className="hearings_data_box_col">
                                {el.final_date}
                              </div>
                              <div className="hearings_data_box_col">
                                {el.client_name}
                              </div>
                              <div className="hearings_data_box_col">
                                {el.task}
                              </div>
                              <div className="hearings_data_box_col">
                                {el.responsible}
                              </div>
                              <div className="hearings_data_box_col">
                                <button
                                  className="viewButton"
                                  value={el.id}
                                  onClick={showTaskPopUp}
                                >
                                  PRZEJDŹ
                                </button>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default SearchPopUp;
